import { useQuery } from '@tanstack/react-query'
import type { AircraftMaintenance, MaintenanceOverview } from '@jupi/shared'
import { api } from '@jupi/ui'

// One namespace for every query here, so a recorded maintenance refreshes the
// fleet and the aircraft in one invalidation.
export const HUOLTO = ['huolto'] as const

export const useFleet = () =>
  useQuery({
    queryKey: [...HUOLTO, 'fleet'],
    queryFn: () => api.get<{ aircraft: AircraftMaintenance[] }>('/api/maintenance/schedules').then((r) => r.aircraft),
  })

export const overviewKey = (registration: string) => [...HUOLTO, 'overview', registration] as const

export const useOverview = (registration: string) =>
  useQuery({
    queryKey: overviewKey(registration),
    queryFn: () => api.get<MaintenanceOverview>(`/api/maintenance/${encodeURIComponent(registration)}/overview`),
  })

// Whether the aircraft carries a GPS unit whose navigation database is tracked.
export const useHasGps = (registration: string) =>
  useQuery({
    queryKey: ['aircraft', registration, 'row'] as const,
    queryFn: () =>
      api.get<{ aircraft: { hasGps: boolean } }>(`/api/aircraft/${encodeURIComponent(registration)}`).then((r) => r.aircraft.hasGps),
  })
